<template>
    <div class="form-constructor__list">
        <div class="title">
            Forms
            <button class="btn btn--link" type="button" @click="onCreate">
                Add new
            </button>
        </div>
        <div v-for="(form, index) in forms" :key="form.id" class="form-item">
            <div class="name">{{ form.title_system }}</div>
            <div class="actions">
                <button
                    @click="onEditForm(form.id)"
                    class="btn btn--link"
                    type="button"
                >
                    Update
                </button>
                <button
                    @click="onDuplicateForm(form.id)"
                    class="btn btn--link"
                    type="button"
                >
                    Duplicate
                </button>
                <button
                    @click="onDelete(form.id)"
                    class="btn btn--link"
                    type="button"
                >
                    Remove
                </button>
            </div>
        </div>
        <ConfirmModal
            v-if="deleteId"
            :title="'Are you sure you want to remove the form?'"
            :onApplyAction="() => handleDelete()"
            :onSecondaryAction="() => onCloseConfirm()"
            :applyLabel="'Delete'"
            :secondaryLabel="'Cancel'"
        ></ConfirmModal>
    </div>
</template>

<script>
import ConfirmModal from "../../../components/ConfirmModal";

export default {
    name: "List_of_Constructor",
    props: [
        "forms",
        "onCreate",
        "onEditForm",
        "onDeleteForm",
        "onDuplicateForm",
    ],
    components: {
        ConfirmModal,
    },
    data() {
        return {
            deleteId: null,
        };
    },

    mounted() {
        console.log(this.forms);
    },
    methods: {
        onDelete(id) {
            this.deleteId = id;
        },

        handleDelete() {
            this.onDeleteForm(this.deleteId);
            this.onCloseConfirm();
        },
        onCloseConfirm() {
            this.deleteId = null;
        },
    },
};
</script>
